/**
 * Class description
 *
 * Created: 2018-07-03
 * @author jonas
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Timeline, TimelineLite, TimelineMax, TweenLite} from "gsap";
import {DungeonQuestGameAssets} from "../DungeonQuestGameAssets";

export class DungeonQuestReelView extends BaseView {
    private _speedLines:TimelineSprite;
    private _speedLinesLoop:TimelineMax | null;

    constructor() {
        super();
    }

    protected initAnimations():void {
        this._speedLines = new TimelineSprite(GameResources.getTextures(DungeonQuestGameAssets.TRANSFORM_INTRO_SPEED_LINES));
        this._speedLines.anchor.set(0, 0.5);
        this._speedLines.rotation = Math.PI * 0.5;
        this._speedLines.blendMode = PIXI.BLEND_MODES.ADD;
        this._speedLines.scale.set(19, 1);
        this._speedLines.alpha = 0;

        const lineMask = new PIXI.Graphics();
        lineMask.beginFill(0, 1);
        lineMask.drawRect(-80, 0, 160, this._speedLines.width);
        lineMask.endFill();


        this._speedLines.position.set(0, -60);
        this._speedLines.mask = lineMask;
        this.addChild(lineMask);
        this.addChild(this._speedLines);
    }

    private startLoop() {
        this.endLoop();
        if(this._speedLinesLoop == null) {
            const animation:Timeline = this._speedLines.getAnimation();
            this._speedLinesLoop = new TimelineMax({repeat : -1});
            this._speedLinesLoop.add(animation);
        }
        this._speedLinesLoop.play(Math.random() * this._speedLinesLoop.duration());
    }

    private endLoop() {
        if(this._speedLinesLoop) {
            if(this._speedLinesLoop.isActive()) {
                this._speedLinesLoop.pause();
            }
        }
    }


    public startSpeedLines():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => this.startLoop());
        tl.add(new TweenLite(this._speedLines, 1.0, {alpha : 0.15}));
        return tl;
    }

    public stopSpeedLines():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(new TweenLite(this._speedLines, 0.2, {alpha : 0}));
        tl.add(() => this.endLoop());
        return tl;
    }


}